module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8_xs-12"
  }, [(_vm.youtubeVideo) ? _c('div', {
    staticClass: "hero youtube",
    domProps: {
      "innerHTML": _vm._s(_vm.youtubeVideo)
    }
  }) : (_vm.vimeoVideo) ? _c('div', {
    staticClass: "hero vimeo",
    domProps: {
      "innerHTML": _vm._s(_vm.vimeoVideo)
    }
  }) : _c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.image.url,
      "alt": _vm.captions
    }
  })]), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions body-captions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82d792e2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Hero.vue
// module id = 243
// module chunks = 1